export default __webpack_public_path__ + "static/media/antp_coloquio_DidierColin.31a51ef2.png";